<!--
 * @Descripttion:
 * @version:
 * @Author: shenlin
 * @Date: 2021-11-02 15:49:14
 * @LastEditors: mobai
 * @LastEditTime: 2022-12-01 09:41:24
-->
<template>
  <div class="app-container">
    <div class="title">
      <div>
        <div>
          待兑现订单数<el-tooltip
            class="item"
            effect="dark"
            content="未申请兑现和已申请但未审核通过的订单"
            placement="top"
          >
            <i class="el-icon-warning-outline"></i>
          </el-tooltip>
          <div>
            <span>{{ stayCashOrderCount }}</span
            >笔
          </div>
          <div>
            未申请<span>{{ notApplyCashOrderCount }}</span
            >笔 | 未通过<span>{{ notPassCashOrderCount }}</span
            >笔
          </div>
        </div>
        <img src="@/assets/images/报告@4x.png" alt="" />
      </div>
      <div>
        <div>
          待兑现的金额（元）<el-tooltip
            class="item"
            effect="dark"
            content="未申请兑现和已申请但未审核通过的订单总额"
            placement="top"
          >
            <i class="el-icon-warning-outline"></i>
          </el-tooltip>
          <div>
            <span>{{ stayCashAmount }}</span
            >元
          </div>
          <div>
            未申请<span>￥{{ notStayCashAmount }}</span> | 未通过<span
              >￥{{ notPassStayCashAmount }}</span
            >
          </div>
        </div>
        <img src="@/assets/images/办结总金额@4x.png" alt="" />
      </div>
      <div>
        <div>
          已兑现的订单数
          <div></div>
          <div>
            <span>{{ cashOrderCount }}</span
            >笔
          </div>
        </div>
        <img src="@/assets/images/报告@4x.png" alt="" />
      </div>
      <div>
        <div>
          已兑现的总金额（元）<el-tooltip
            class="item"
            effect="dark"
            content="审核通过的订单总额"
            placement="top"
          >
            <i class="el-icon-warning-outline"></i>
          </el-tooltip>
          <div>
            <span>{{ cashAmount }}</span
            >元
          </div>
          <span v-if="detailType" @click="onDetail()" style="color: #0070ff"
            >查看详情></span
          >
        </div>
        <img src="@/assets/images/未入库@4x.png" alt="" />
      </div>
    </div>
    <div class="header">
      <div class="header-serach">
        <el-form :inline="true" :model="ruleform">
          <el-form-item label="">
            <el-input
              v-model="ruleform.key"
              :placeholder="placeholderText"
              @keyup.enter.native="getSearch"
              clearable
              @clear="getSearch"
            >
              <i
                @click="getSearch"
                slot="suffix"
                class="el-input__icon el-icon-search"
              ></i
            ></el-input>
          </el-form-item>
          <el-form-item label="订单状态：">
            <el-select
              v-model="ruleform.orderStatus"
              placeholder="请选择"
              @change="getPoss"
              clearable
            >
              <el-option
                v-for="item in statusList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="申请兑现状态：">
            <el-select
              v-model="ruleform.applyStatus"
              placeholder="请选择"
              @change="getPoss"
              clearable
            >
              <el-option
                v-for="item in apply"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="取消订单审核：">
            <el-select
              v-model="ruleform.cancelStatus"
              placeholder="请选择"
              @change="getPoss"
              clearable
            >
              <el-option
                v-for="item in canList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="时间：">
            <el-date-picker
              v-model="enterpriseTime"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              @change="getPoss"
              value-format="yyyy-MM-dd"
            >
            </el-date-picker>
          </el-form-item>
        </el-form>
      </div>
      <div class="header-btn">
        <div class="btn-left">
          <span>审核兑现状态：</span>
          <el-radio-group
            v-model="labelPosition"
            @change="listLiveData"
            size="small"
          >
            <el-radio-button
              :label="item.status"
              v-for="(item, index) in btnList"
              :key="index"
              >{{ item.name }} {{ item.num }}</el-radio-button
            >
          </el-radio-group>
        </div>
        <div class="btn-right">
          <el-button
            size="medium"
            v-if="roleText !== '机构' && roleText !== '服务机构'"
            @click="cancelOrder"
            type="danger"
            >取消订单</el-button
          >
          <Debounce
            :time="5000"
            :isDebounce="3"
            v-if="roleText !== '机构' && roleText !== '服务机构'"
          >
            <button
              type="button"
              class="el-button el-button--primary el-button--medium"
              @click="downloadOrder"
            >
              导 出
            </button>
          </Debounce>
        </div>
      </div>
    </div>
    <component
      :is="componentId"
      :tableData="tableData"
      @selectChange="selectChange"
      @history="history"
    ></component>
    <div class="table-page">
      <el-pagination
        background
        layout="total,prev, pager, next, sizes, jumper"
        :current-page.sync="currentPage"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :page-size="pageSize"
        :total="totalRecord"
      >
      </el-pagination>
    </div>
    <el-dialog
      title="已兑现详情"
      :visible.sync="centerDialogVisible"
      width="35%"
      center
    >
      <div class="header-serach">
        <el-date-picker
          v-model="videoTime"
          type="daterange"
          @change="getActiveList"
          value-format="yyyy-MM-dd HH:mm:ss"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          clearable
        >
        </el-date-picker>
        <el-button type="primary" @click="exportList">导出</el-button>
      </div>
      <el-table
        :data="activeTableData"
        style="width: 100%"
        :header-cell-style="{ background: '#fafafa' }"
        height="300"
        @sort-change="changeSort"
        :default-sort="{ prop: 'cashAmount', order: 'descending' }"
      >
        <el-table-column
          prop="orgName"
          label="机构名称"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="cashAmount"
          label="已兑现总金额（元）"
          sortable="custom"
          :sort-orders="['ascending', 'descending']"
        ></el-table-column>
      </el-table>
      <div class="table-page">
        <el-pagination
          background
          layout="total,prev, pager, next, sizes, jumper"
          :current-page.sync="activeCurrentPage"
          @size-change="activeHandleSizeChange"
          @current-change="activeHandleCurrentChange"
          :page-size="activePageSize"
          :total="activeTotalRecord"
        >
        </el-pagination>
      </div>
    </el-dialog>
    <el-dialog
      title="取消订单"
      v-if="cancelOrderVisiblel"
      :close-on-click-modal="false"
      :visible.sync="cancelOrderVisiblel"
      :before-close="handleClose"
      width="30%"
    >
      <div>
        当前选中<span style="color: #1890ff">{{
          this.selectedList.length
        }}</span
        >笔订单，其中：
      </div>
      <div style="margin: 5px 0">
        有<span style="color: #1890ff">{{ number1(this.selectedList) }}</span>
        笔订单企业已使用服务券，取消订单需要审核。
      </div>
      <div style="margin: 5px 0">
        有<span style="color: #1890ff">{{ number2(this.selectedList) }}</span>
        笔订单待确认或未使用服务券，确认后直接取消。
      </div>
      <div>请输入“我确认取消订单”继续</div>
      <!-- <span style="line-height: 20px"
        >是否确认取消选中的
        <span class="num-color">{{ this.selectedList.length }}</span>
        笔订单？取消后订单将失效，请事先与企业或机构进行确认再操作。若要取消，请在以下文本框输入“取消订单”</span
      > -->
      <el-form
        ref="cancelOrderform"
        :model="cancelOrderform"
        label-width="0"
        style="margin: 15px 0"
        :rules="rules"
      >
        <el-form-item prop="cancelOrderMsg">
          <el-input
            v-model="cancelOrderform.cancelOrderMsg"
            placeholder="请输入“我确认取消订单”"
          ></el-input>
        </el-form-item>
        <!-- <el-form-item prop="checkKnow">
          <el-checkbox v-model="cancelOrderform.checkKnow"
            >我已知晓取消订单风险，并与买卖双方取得联系</el-checkbox
          >
        </el-form-item> -->
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <Debounce :time="5000" :isDebounce="3">
          <button
            type="button"
            class="el-button el-button--primary el-button--medium"
            @click="submitCancelOrder"
          >
            确 定
          </button>
        </Debounce>
      </span>
    </el-dialog>
    <el-dialog title="审核记录" :visible.sync="show" width="30%">
      <div class="title">展示取消订单的审核记录</div>
      <img v-if="!activities.length" src="@/assets/es-sfss.png" alt="" />
      <el-timeline>
        <el-timeline-item
          v-for="(activity, index) in activities"
          :key="index"
          color="#1890ff"
          :size="activity.size"
        >
          <h4>{{ activity.statusName }}</h4>
          <p>备注：{{ activity.remark || '-' }}</p>
          <p>操作人：{{ activity.createBy || '-' }}</p>
          <p>操作时间：{{ activity.createTime || '-' }}</p>
        </el-timeline-item>
      </el-timeline>
    </el-dialog>
  </div>
</template>

<script>
import {
  listByPage,
  auditStatusCount,
  entStatusCount,
  cashList,
  exportCashList,
  cancelOrders,
  downloadOrders
} from '@api/orderManagement'
import { listByCancelRecord } from '@api/yardIntermediary/cancelOrder'
import mechanism from './components/table-mechanism'
import enterprise from './components/table-enterprise'
export default {
  data() {
    const cancelOrderMsg = (rule, value, cb) => {
      if (value === '我确认取消订单') {
        return cb()
      }
      cb(new Error('请输入“我确认取消订单”'))
    }
    const checkKnow = (rule, value, cb) => {
      if (value) {
        return cb()
      }
      cb(new Error('请确认知晓取消订单的风险'))
    }
    return {
      notApplyCashOrderCount: '',
      notPassCashOrderCount: '',
      notStayCashAmount: '',
      notPassStayCashAmount: '',
      centerDialogVisible: false,
      ruleform: {
        key: '',
        orderStatus: '',
        applyStatus: '',
        cancelStatus: '',
        startTime: '',
        endTime: '',
        auditStatus: ''
      },
      activities: [],
      cancelOrderVisiblel: false,
      placeholderText: '搜索订单编号/商品/企业/机构名称',
      enterpriseTime: '', // 时间
      btnList: [
        {
          name: '全部',
          status: 0
        },
        {
          name: '待审核',
          num: 0,
          status: 1
        },
        {
          name: '审核通过',
          num: 0,
          status: 2
        },
        {
          name: '审核驳回',
          num: 0,
          status: 3
        }
      ],
      labelPosition: 0,
      statusList: [
        { value: '', label: '全部' },
        { value: 0, label: '待机构确认' },
        { value: 1, label: '待企业确认' },
        { value: 2, label: '待评价' },
        { value: 3, label: '已完成' },
        { value: 4, label: '已失效' }
      ],
      apply: [
        { value: '', label: '全部' },
        { value: 1, label: '已申请' },
        { value: 0, label: '未申请' }
      ],
      canList: [
        { value: '', label: '全部' },
        { value: 1, label: '待审核' },
        { value: 2, label: '审核通过' },
        { value: 3, label: '审核驳回' }
      ],
      tableData: [],
      pageSize: 10,
      currentPage: 1,
      totalRecord: 0,
      stayCashOrderCount: null, // 待兑现订单数
      cashOrderCount: null, // 已兑现的订单数
      stayCashAmount: null, // 待兑现的金额（元）
      cashAmount: null, // 已兑现的总金额（元）
      detailType: null, // 已兑现的总金额详情 ，0-不展示，1-展示
      activeCurrentPage: 1,
      activePageSize: 10,
      activeTotalRecord: 0,
      activeTableData: [],
      videoTime: '',
      sort: 1,
      roleText: '', // roleText
      selectedList: [], // 已选集合
      show: false, // 取消订单确认弹框
      cancelOrderform: {
        cancelOrderMsg: '', // 取消订单确认框输入内容
        checkKnow: false // 了解取消须知
      },
      rules: {
        cancelOrderMsg: [
          { required: true, validator: cancelOrderMsg, trigger: 'blur' }
        ],
        checkKnow: [{ required: true, validator: checkKnow, trigger: 'change' }]
      }
    }
  },

  watch: {},
  computed: {
    componentId() {
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.roleText = this.$store.state.user.userInfo.roleText
      return this.roleText === '机构' || this.roleText === '服务机构'
        ? enterprise
        : mechanism
    },
    number1() {
      return function (val) {
        let n = 0
        val.forEach(item => {
          if (item.couponUse == 1) n++
        })
        return n
      }
    },
    number2() {
      return function (val) {
        let n = 0
        val.forEach(item => {
          if (item.couponUse !== 1) n++
        })
        return n
      }
    }
  },
  created() { },
  mounted() {
    this.listLiveData()
    this.auditCount()
  },
  methods: {
    // 弹框关闭初始化数据
    handleClose() {
      this.cancelOrderform = {
        cancelOrderMsg: '', // 取消订单确认框输入内容
        checkKnow: false // 了解取消须知
      }
      this.cancelOrderVisiblel = false
    },
    // downloadOrders订单导出
    downloadOrder() {
      let paramas = {
        orderStatus: this.ruleform.orderStatus,
        applyStatus: this.ruleform.applyStatus,
        auditStatus: this.labelPosition === 0 ? '' : this.labelPosition,
        startTime: this.enterpriseTime ? this.enterpriseTime[0] : '',
        endTime: this.enterpriseTime ? this.enterpriseTime[1] : '',
        cancelStatus: this.ruleform.cancelStatus
      }
      if (this.roleText === '机构' || this.roleText === '服务机构') {
        paramas.key = this.ruleform.key
      } else {
        paramas.govKey = this.ruleform.key
      }
      downloadOrders(paramas)
    },
    // 取消订单确定按钮
    submitCancelOrder() {
      this.$refs['cancelOrderform'].validate(valid => {
        if (valid) {
          let idList = []
          this.selectedList.forEach(item => {
            idList.push(item.id)
          })
          const ids = idList.join(',')
          cancelOrders({ ids }).then(res => {
            if (res.data.code === '0000') {
              this.$message({
                message: '取消成功',
                type: 'success'
              })
              this.handleClose()
              this.getPoss()
            }
          })
        } else {
          return false
        }
      })
    },
    // 取消订单点击事件 判断是否有选中数据 - 提示确认框 - 取消操作
    cancelOrder() {
      console.log(this.selectedList)
      if (this.selectedList.length == 0) {
        this.$message({
          message: '请先勾选订单',
          type: 'warning'
        })
        return false
      }
      this.cancelOrderVisiblel = true
    },
    history(val) {
      this.show = true
      this.listByCancelRecord(val)
    },
    listByCancelRecord(id) {
      listByCancelRecord({ id: id }).then(res => {
        if (res.data.code == '0000') {
          this.activities = res.data.data || []
        }
      })
    },
    // 选择事件
    selectChange(val) {
      this.selectedList = val
      console.log(this.selectedList, 'selectedList')
    },
    auditCount() {
      let url = ''
      if (this.roleText === '机构' || this.roleText === '服务机构') {
        url = entStatusCount()
        this.placeholderText = '订单编号/商品名称/下单企业名称'
      } else {
        url = auditStatusCount()
        this.placeholderText = '搜索订单编号/商品/企业/机构名称'
      }
      url.then(res => {
        const list = res.data.data
        this.btnList[1].num = list.waitAudit
        this.btnList[2].num = list.passAudit
        this.btnList[3].num = list.rejectAudit
      })
    },
    // 视频名称
    getSearch() {
      this.currentPage = 1
      this.listLiveData()
    },
    // 所有类别
    getPoss() {
      this.currentPage = 1
      this.listLiveData()
    },
    activeHandleSizeChange(val) {
      this.activePageSize = val
      this.getActiveList()
    },
    activeHandleCurrentChange(currentPage) {
      this.activeCurrentPage = currentPage
      this.getActiveList()
    },
    //  表格翻页
    handleCurrentChange(currentPage, e) {
      this.currentPage = currentPage
      this.listLiveData()
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.listLiveData()
    },
    // 列表
    listLiveData() {
      let par = {
        pageNum: this.currentPage,
        pageSize: this.pageSize,
        orderStatus: this.ruleform.orderStatus,
        applyStatus: this.ruleform.applyStatus,
        cancelStatus: this.ruleform.cancelStatus,
        auditStatus: this.labelPosition === 0 ? '' : this.labelPosition,
        startTime: this.enterpriseTime ? this.enterpriseTime[0] : '',
        endTime: this.enterpriseTime ? this.enterpriseTime[1] : ''
      }
      if (this.roleText === '机构' || this.roleText === '服务机构') {
        par.key = this.ruleform.key
      } else {
        par.govKey = this.ruleform.key
      }
      listByPage(par).then(res => {
        if (res.data.code == '0000') {
          const list = res.data.data
          this.notApplyCashOrderCount = list.notApplyCashOrderCount
          this.notPassCashOrderCount = list.notPassCashOrderCount
          this.notStayCashAmount = list.notStayCashAmount
          this.notPassStayCashAmount = list.notPassStayCashAmount
          this.stayCashOrderCount = list.stayCashOrderCount
          this.cashOrderCount = list.cashOrderCount
          this.stayCashAmount = list.stayCashAmount
          this.cashAmount = list.cashAmount
          this.detailType = list.detailType
          this.tableData = list.results || []
          this.tableData.map(value => {
            let branch = value.createTime.split(':')
            value.createTime = branch[0] + ':' + branch[1]
          })
          this.totalRecord = list.totalRecord || 0
        }
      })
    },
    // 查看详情
    onDetail() {
      this.centerDialogVisible = true
      this.getActiveList()
    },
    getActiveList() {
      let par = {
        startDate: this.videoTime ? this.videoTime[0] : '',
        endDate: this.videoTime ? this.videoTime[1] : '',
        sort: this.sort,
        pageNum: this.activeCurrentPage,
        pageSize: this.activePageSize
      }
      cashList(par).then(res => {
        if (res.data.code == '0000') {
          this.activeTableData = res.data.data.results || []
          this.activeTotalRecord = res.data.data.totalRecord || 0
        }
      })
    },
    changeSort(val) {
      this.sort = val.order == 'descending' ? '1' : '0'
      this.getActiveList()
    },
    // 文件导出
    exportList() {
      let params = {
        startDate: this.videoTime ? this.videoTime[0] : '',
        endDate: this.videoTime ? this.videoTime[1] : '',
        sort: this.sort,
        pageNum: this.activeCurrentPage,
        pageSize: this.activePageSize
      }
      exportCashList(params)
    }
  }
}
</script>

<style lang="scss" scoped>
.app-container {
  padding: 0;
  background: none;
}
.num-color {
  color: #1890ff;
}
/deep/ .el-button--medium {
  height: 32px;
  line-height: 0;
}
/deep/.el-dialog {
  .el-dialog__header {
    padding-bottom: 20px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  }
  .el-dialog__body {
    height: 500px;
    overflow: auto;
    img {
      display: block;
      margin: 20px auto;
    }
  }
  .title {
    background: rgb(244, 249, 252);
    padding: 10px;
    border: 1px solid rgba(0, 0, 0, 0.1);
  }
}

.title {
  width: 100%;
  align-items: center;
  display: flex;
  justify-content: space-between;
  margin-bottom: 15px;
  background: white;
  padding: 16px;
  > div {
    width: 24%;
    display: flex;
    justify-content: space-between;
    background: linear-gradient(
      180deg,
      rgba(0, 112, 255, 0.08) 0%,
      rgba(255, 255, 255, 0) 100%
    );
    border-radius: 2px;
    padding: 20px 16px;
    img {
      width: 80px;
      height: 80px;
    }
    display: flex;
    > div {
      margin-left: 10px;
      font-size: 14px;
      color: rgba(102, 102, 102, 100);
      > div:nth-child(2) {
        margin: 5px 0 10px;
        color: rgba(0, 0, 0, 0.85);
        > span {
          font-size: 28px;
        }
      }
      > div:nth-child(3) {
        > span {
          color: #1890ff;
        }
      }
    }
  }
}
/deep/ .el-dialog__wrapper {
  .el-dialog__body {
    .header-serach {
      display: flex;
      margin-bottom: 20px;
      justify-content: space-between;
    }
  }
}
.header {
  background: white;
  // display: flex;
  padding: 16px;
  .header-serach {
    .el-input {
      width: 300px;
      margin-right: 30px;
    }
  }
  .addPru {
    width: 100px;
    display: inline-block;
    text-align: center;
    position: absolute;
    right: 50px;
    height: 36px;
    border-radius: 5px;
    line-height: 36px;
    background: #1890ff;
    color: #fff;
    cursor: pointer;
  }
  .header-btn {
    font-size: 16px;
    display: flex;
    justify-content: space-between;
    .btn-right {
      span {
        font-size: 15px;
        color: #333;
        margin-right: 20px;
        cursor: pointer;
      }
    }
  }
}
/deep/.el-dialog {
  .el-dialog__header {
    padding-bottom: 20px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  }
  .upload {
    display: inline-block;
    color: #1890ff;
    margin-bottom: 16px;
    margin-left: 40px;
    cursor: pointer;
  }
  .upload-demo {
    margin-left: 40px;
  }
  .el-dialog__footer {
    margin-top: 10px;
    padding-top: 16px;
    text-align: right;
    border-top: 1px solid rgba(0, 0, 0, 0.1);
  }
  b {
    display: inline-block;
    width: 90%;
    height: 90px;
    line-height: 80px;
    text-align: center;
    font-size: 18px;
    margin: 20px 20px 0 0;
    i {
      display: inline-block;
      height: 50px;
      font-size: 35px;
      color: rgb(0, 153, 255);
      margin: 15px 20px 0;
      vertical-align: sub;
    }
    .error {
      color: #f00;
    }
  }
}
.actcolor {
  color: #1890ff;
}
.nocolor {
  color: rgba(0, 0, 0, 0.3);
}
.changeAppeal {
  cursor: pointer;
  color: #1890ff;
}
.el-table::before {
  height: 0px;
}
.table-page {
  background: white;
  width: 100%;
  text-align: center;
  padding: 20px;
}
.sharing-code {
  display: flex;
  span {
    line-height: 34px;
  }
  /deep/.el-input__inner {
    border-top-right-radius: 0 !important;
    border-bottom-right-radius: 0 !important;
  }
  /deep/.el-button--medium {
    border-top-left-radius: 0 !important;
    border-bottom-left-radius: 0 !important;
  }
}
.exhibition {
  // margin-top: 20px;
  margin-left: -25px;
  display: flex;
  #qrcode {
    width: 125px;
    height: 150px;
    margin: 20px auto;
  }
  .refreshs {
    margin: 20px auto;
    span {
      margin-left: 22px;
    }
    .refresh {
      margin-left: 50px;
      cursor: pointer;
    }
  }
}
/deep/ .el-select {
  width: 180px;
}
/deep/.el-range-editor--medium .el-range-separator {
  width: 40px !important;
}
</style>
<style lang="scss">
.el-tooltip__popper {
  max-width: 300px;
}
.el-popover {
  min-width: 100px !important;
}
</style>
